import { render, staticRenderFns } from "./MtipotransporteForm.vue?vue&type=template&id=52fc18a9"
import script from "./MtipotransporteForm.vue?vue&type=script&lang=js"
export * from "./MtipotransporteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports